export default __webpack_public_path__ + "static/media/Courtney.33c6ab63.png";